import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiConfig} from '@employee-configs/api.config';
import * as EmployeeModels from '@employee-models/index';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class EmployeeService {

    private lastUserId: number;
    private employee: EmployeeModels.DM.IEmployeeProfileModel;


    constructor(private httpClient: HttpClient) {
    }

    getEmployeeProfileById(userId: number): Observable<EmployeeModels.DM.IEmployeeProfileModel> {
        return this.httpClient.get<EmployeeModels.DM.IEmployeeProfileModel>(
            `${ApiConfig.Employee.getById}/${userId}`
        ).pipe(
            map(data => {
                this.lastUserId = userId;
                this.employee = data;
                return data;
            })
        );
    }

    getRequestList(gridRequest: EmployeeModels.DM.IRequestListGridRequest): Observable<EmployeeModels.DM.IRequestListGridResponse> {
        return this.httpClient.post<EmployeeModels.DM.IRequestListGridResponse>(ApiConfig.Employee.requestRange, gridRequest);
    }
    
    getCleRequestList(gridRequest: EmployeeModels.DM.IRequestListGridRequest): Observable<EmployeeModels.DM.ICleRequestListGridResponse> {
        return this.httpClient.post<EmployeeModels.DM.ICleRequestListGridResponse>(ApiConfig.Employee.cleRequestRange, gridRequest);
    }
}
